import { environment } from '../../../environments/environment';

const ENDPOINT_MSRUT  = '/cliente/evaluar';
const ENDPOINT_MSDOC  = '/cedula/evaluar';
const ENDPOINT_MSPIN  = '/codigo/evaluar';
const ENDPOINT_MSRESEND  = '/codigo/reenviar';
const ENDPOINT_MSCREATE = '/clave/crear';
const ENDPOINT_MSTOKEN = '/token/expirarToken';

export const ENDPOINTS_ARRAY = [
  ENDPOINT_MSRUT,
  ENDPOINT_MSDOC,
  ENDPOINT_MSPIN,
  ENDPOINT_MSRESEND,
  ENDPOINT_MSCREATE,
  ENDPOINT_MSTOKEN
]


// export const ENDPOINT = `http://${IP}:${PORT}${ENTORNO}`;
export const ENDPOINTRUT     = `${environment.creacionClave.URL_ORQUESTADOR}/cliente/evaluar`;
export const ENDPOINTDOC     = `${environment.creacionClave.URL_ORQUESTADOR}/cedula/evaluar`;
export const ENDPOINTVALIDAPIN  = `${environment.creacionClave.URL_ORQUESTADOR}/codigo/evaluar`;
export const ENDPOINTREENVIO = `${environment.creacionClave.URL_ORQUESTADOR}/codigo/reenviar`;
export const ENDPOINTCREACLAVE = `${environment.creacionClave.URL_ORQUESTADOR}/clave/crear`;
export const ENDPOINTKILLTOKEN = `${environment.creacionClave.URL_ORQUESTADOR}/token/expirarToken`;



// WEBPACK FOOTER //
// ./src/app/features/creacion-clave/creacion-clave.config.ts